<template>
    <Content
        :model="model"
        :content="content"
        :api-key="apiKey"
        :custom-components="registeredComponents"
        :context="{
            openLogin: () => $store.dispatch('ui/openLogin'),
            openRegistration: () => $store.dispatch('ui/openRegistration'),
        }"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { BuilderContent } from '@builder.io/sdk-vue';
import { Content } from '@builder.io/sdk-vue';
import { useRouteData } from '@/composables/routeData';
import { keepUrlGuard } from '@/router/guards';
import { registeredComponents } from '@/plugins/builder';

export default defineComponent({
    name: 'BuilderPage',
    components: {
        Content,
    },
    beforeRouteUpdate: keepUrlGuard,
    beforeRouteEnter: keepUrlGuard,
    setup() {
        const [content] = useRouteData<[BuilderContent]>();
        const apiKey = import.meta.env.MIX_BUILDER_IO_API_KEY;
        const model = import.meta.env.MIX_BUILDER_IO_PAGE_MODEL;

        return {
            content,
            apiKey,
            model,
            registeredComponents,
        };
    },
});
</script>

<!-- eslint-disable vue-scoped-css/enforce-style-type -- builder content doesn't have a scopeable class name-->
<style lang="scss">
// builder adds wrapping elements to texts.
// In order for truncate to work, all childs need to obey the setup.
.truncate .builder-text {
    &,
    * {
        text-overflow: ellipsis;
        overflow: inherit;
        display: inline !important;
    }
}
</style>
